// 15.G: общий UI разметки заказчика — тумблер режима + строка полей на находку.
// Поля: позиция заказчика (согласен/не согласен/уточнить) + стр. + комментарий.
import { Pencil } from 'lucide-react';
import type { MarkupLabel } from '@/hooks/useMarkup';

const STANCE: { v: string; label: string }[] = [
  { v: '', label: '— позиция —' },
  { v: 'agree', label: 'Согласен' },
  { v: 'disagree', label: 'Не согласен' },
  { v: 'clarify', label: 'Уточнить' },
];

/** Тумблер режима разметки + подсказка про автосохранение. */
export function MarkupToggle({ on, onToggle, savedAt }: {
  on: boolean; onToggle: () => void; savedAt: string | null;
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
      <button type="button" onClick={onToggle}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 12px', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer', border: `1px solid ${on ? '#0A1628' : '#E5E7EB'}`, background: on ? '#0A1628' : '#fff', color: on ? '#fff' : '#374151' }}>
        <Pencil size={14} /> {on ? 'Разметка: вкл' : 'Режим разметки'}
      </button>
      {on && (
        <span style={{ fontSize: 12, color: '#6B7280' }}>
          по каждой находке: позиция + стр. + комментарий · автосохранение{savedAt ? ` · сохранено ${savedAt}` : ''}
        </span>
      )}
    </div>
  );
}

/** Строка полей разметки под одной находкой (видна только в режиме разметки). */
export function MarkupFields({ value, onChange }: {
  value?: MarkupLabel; onChange: (patch: Partial<MarkupLabel>) => void;
}) {
  const v = value || { verdict: '', page: '', comment: '' };
  return (
    <div onClick={(e) => e.stopPropagation()}
      style={{ marginTop: 8, padding: '10px 12px', background: 'rgba(10,22,40,.03)', border: '1px dashed #CBD5E1', borderRadius: 8, display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
      <select value={v.verdict} onChange={(e) => onChange({ verdict: e.target.value })}
        style={{ fontSize: 12.5, padding: '5px 8px', border: '1px solid #CBD5E1', borderRadius: 6, background: '#fff', color: v.verdict ? '#0A1628' : '#9CA3AF' }}>
        {STANCE.map((s) => <option key={s.v} value={s.v}>{s.label}</option>)}
      </select>
      <input type="text" inputMode="numeric" placeholder="стр." value={v.page}
        onChange={(e) => onChange({ page: e.target.value.replace(/[^0-9]/g, '') })}
        style={{ width: 66, fontSize: 12.5, padding: '5px 8px', border: '1px solid #CBD5E1', borderRadius: 6 }} />
      <input type="text" placeholder="комментарий заказчика" value={v.comment}
        onChange={(e) => onChange({ comment: e.target.value })}
        style={{ flex: 1, minWidth: 180, fontSize: 12.5, padding: '5px 8px', border: '1px solid #CBD5E1', borderRadius: 6 }} />
    </div>
  );
}
